import React from 'react';
import { ArrowRightIcon, MessageSquareTextIcon, CalendarCheckIcon, ArrowLeftRightIcon } from 'lucide-react';
import { automationSteps } from '../data/homepage';
const icons = {
  capture: MessageSquareTextIcon,
  moving: CalendarCheckIcon,
  twice: ArrowLeftRightIcon
} as const;
export function AutomationSection() {
  return <section aria-labelledby="automation-title" className="bg-paper" data-id="element-15" data-mp="fw8hpaex8j44">
      <div className="mx-auto max-w-[1280px] px-5 py-12 md:px-8 md:py-16 lg:py-20" data-id="element-16" data-mp="3o9xi88y2x54j">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between lg:gap-16" data-id="element-17" data-mp="3jbvzxq8h99u4">
          <div data-id="element-18" data-mp="238xww83w2qr">
            <h2 id="automation-title" className="max-w-[620px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-19" data-mp="23shsihbh17f">
              Fewer missed leads. Less manual work.
            </h2>
            <p className="mt-4 max-w-[560px] text-[17px] leading-[1.6] text-ink/80" data-id="element-20" data-mp="1dgurctl00qi3">
              Connect the inquiry, the conversation, and the work that follows.
            </p>
          </div>
          <a href="#contact" className="inline-flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap text-[16px] font-bold text-ink underline decoration-brand-orange decoration-2 underline-offset-[6px] transition-colors duration-150 ease-out hover:decoration-ink lg:self-end" data-id="element-21" data-mp="3ssjuqtk5qxzh">
            Talk through your workflow
            <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-22" data-mp="3a33gz4jgp914" />
          </a>
        </div>

        {/* A restrained left-to-right sequence: inquiry → sale → connected systems. */}
        <ol className="mt-10 grid gap-8 md:grid-cols-3 md:gap-8" data-id="element-23" data-mp="3j38jb09sth8f">
          {automationSteps.map((step, i) => {
          const Icon = icons[step.id as keyof typeof icons];
          const isLast = i === automationSteps.length - 1;
          return <li key={step.id} className="flex flex-col" data-id="element-24" data-mp="2rbkf5116c10o" data-mpi={i}>
                <div className="flex items-center gap-4" data-id="element-25" data-mp="2vccmfoqhjvub">
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-mint text-brand-greenDeep" data-id="element-26" data-mp="2ixm5v7xi5yv">
                    <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden data-id="element-27" data-mp="3tq0a8dsgzw4v" />
                  </span>
                  {!isLast && <span className="hidden h-px flex-1 bg-rule md:block" aria-hidden data-id="element-28" data-mp="c7fj21d37sx8" />}
                </div>
                <h3 className="mt-5 text-[20px] font-bold leading-snug text-ink" data-id="element-29" data-mp="7a5x4vowpze5">{step.title}</h3>
                <p className="mt-2 max-w-[360px] text-[16px] leading-[1.6] text-ink/80" data-id="element-30" data-mp="3fpzc363lb2t3">{step.body}</p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}